module.exports = __webpack_public_path__ + "img/search.85e4557d.png";